import React from 'react'

import { SmallText, Text, Title } from './Text'
import FlexGrid from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Separator from '../helpers/Separator'
import { COLORS } from '@btime/constants'

const IconBlock = ({ icon, iconSize, iconColor, title, subtitle, text, color, children }) => (
  <FlexGrid direction="column" align="center" justify="center">
    <Separator weight={4} />
    <Icon name={icon} color={iconColor || COLORS.light3} size={iconSize || '4rem'} />
    <Separator weight={4} />
    <Title size="h5" align="center" color={color || COLORS.dark3} maxWidth={25}>
      {title}
    </Title>
    <Text align="center" color={color || COLORS.dark3} maxWidth={25}>
      {subtitle}
    </Text>
    <Separator />
    <SmallText align="center" color={color}>
      {text}
    </SmallText>
    <Separator weight={4} />
    {children}
  </FlexGrid>
)

export default IconBlock
